import {ChartMode, ChartModeColors} from '../../models';

const light = [
    "#C62828","#E65100","#827717","#1B5E20",
    "#006064","#0D47A1","#4A148C","#760A3A",
    "#8B2500","#AD1457","#BF360C","#A0520F",
    "#2E7D32","#00838F","#1565C0","#6A1B9A",
    "#9C1150","#8D6E63","#880E4F","#4E342E",
    "#B36200","#33691E","#00695C","#283593",
    "#7B1FA2","#C2185B","#5D4037", "#B71C1C",
    "#6D4C41","#9E6C00","#1A6B1A","#004D40",
    "#1A237E","#311B92","#D81B60","#3E2723",
    "#D32F2F","#A04000","#558B2F","#00600F",
    "#0277BD","#0288D1","#4527A0","#E91E63",
    "#795548","#1976D2","#0097A7","#00796B",
    "#388E3C","#512DA8","#2962FF","#0097C7",
    "#1A7A1A","#6A0DAD","#C84B00","#37474F",
    "#455A64","#546E7A","#607D8B","#263238",
];

const dark = [
    "#FF4444","#FF6D00","#FFE600","#39FF14",
    "#00E5FF","#2979FF","#7C4DFF","#FF40FF",
    "#FFD700","#FF6B6B","#FF8C42","#F5FF33",
    "#00FF7F","#00BCD4","#448AFF","#651FFF",
    "#FF00DD","#FFC107","#FF8FA3","#FFAA44",
    "#CFFF04","#00E676","#00FFFF","#82B1FF",
    "#AA00FF","#FF1493","#FF9800","#FF3CAC",
    "#FFB347","#AAFF00","#00C853","#1DE9B6",
    "#00B0FF","#D500F9","#F50057","#FF6F00",
    "#E91E8C","#FFC857","#90EE00","#4CAF50",
    "#64FFDA","#40C4FF","#E040FB","#C51162",
    "#BF360C","#80DEEA","#B39DDB","#FFCC80",
    "#A5D6A7","#F48FB1","#39FFCA","#FF6EFF",
    "#FFE333","#33FFBD","#FF334D","#FF7043",
    "#26C6DA","#AB47BC","#8D6E63","#78909C"
];

export const CHART_PALETTES: Record<ChartMode, string[]> = { light, dark };

export const CHART_MODE_COLORS: Record<ChartMode, ChartModeColors> = {
    light: {
        basicColor: "#000000",
        oppositeColor: "#FFFFFF",
        background: "#FFFFFF",
        toolTipBackground: "rgba(255,255,255,.9)",
    },
    dark: {
        basicColor: "#FFFFFF",
        oppositeColor: "#000000",
        background: "#00000f",
        toolTipBackground: "rgba(0,0,0,.9)",
    },
};
